import { MD3LightTheme as DefaultTheme, MD3Theme } from "react-native-paper";
import colors from "./colors";

const theme: MD3Theme = {
  ...DefaultTheme,
  roundness: 1.6,
  version: 3,
  colors: {
    ...DefaultTheme.colors,
    primary: colors.primary.DEFAULT,
    secondary: colors.secondary.DEFAULT,
    background: "white",
    surface: "white",
    outline: colors.sky.dark,
    onSurfaceVariant: colors.ink.lighter,
    elevation: {
      ...DefaultTheme.colors.elevation,
      level3: colors.sky.white,
    },
  },
};

export default theme;
